import { PriceStickerEditor } from '@/widgets/price-sticker-editor';
import { useDocumentTitle } from '@/shared/lib';

// /price-stickers: small price stickers on the Brother label printer's 62 mm roll, one PDF page per piece of the roll.
export function PriceStickersPage() {
  useDocumentTitle("Price Stickers — Uncle Wiener's Label Studio");
  return <PriceStickerEditor />;
}
